<template>
    <el-dialog
        :title="title"
        width="1100px"
        top="4vh"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        class="classes-strategy-dialog"
    >
        <el-form
            :model="form"
            :rules="rules"
            label-width="150px"
            class="from"
            ref="ruleForm"
        >
            <el-row :gutter="2">
                <el-col :span="8">
                    <el-form-item label="分公司" prop="companyName">
                        <advance-dialog
                            v-model="form.companyName"
                            :params="companyParams"
                            :mValue="form.companyName"
                            :disabled="title === '编辑'"
                            @getAdvanceValue="
                                (data) => getSelectValue(data, 'companyName')
                            "
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="服务平台" prop="siteName">
                        <advance-dialog
                            v-model="form.siteName"
                            :params="siteParams"
                            :mValue="form.siteName"
                            :formData="form"
                            :disabled="title === '编辑' || !form.companyName"
                            @getAdvanceValue="
                                (data) => getSelectValue(data, 'siteName')
                            "
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="线路模式" prop="lineLevel">
                        <otpSelect
                            :optionNum="'TMS_LINE_MODE1'"
                            :mValue="form.lineLevel"
                            placeholder="请选择线路模式"
                            :prop="'lineLevel'"
                            :disabled="title === '编辑'"
                            @getSelectValue="
                                (data) => getSelectValue(data, 'lineLevel')
                            "
                        ></otpSelect>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="线路" prop="lineName">
                        <advance-dialog
                            v-model="form.lineName"
                            :params="lineParams"
                            :mValue="form.lineName"
                            :formData="form"
                            :disabled="
                                form.lineLevel === ''
                                    ? true
                                    : false || title === '编辑'
                            "
                            @getAdvanceValue="
                                (data) => getSelectValue(data, 'lineName')
                            "
                        >
                        </advance-dialog>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="班次截单时间" prop="shiftOrderEndTime">
                        <el-time-picker
                            v-model="form.shiftOrderEndTime"
                            :picker-options="{ format: 'HH:mm' }"
                            :value-format="'HH:mm'"
                            placeholder="请选择"
                            :disabled="!form.siteName"
                            @change="shiftOrderEndTimeChange"
                        >
                        </el-time-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="班次名称">
                        <el-input
                            v-model.trim="form.shiftName"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row :gutter="10" class="row-item">
                <el-col :span="12">
                    <el-form-item
                        label="排车时长(min)"
                        prop="scheduleVehicleTime"
                    >
                        <el-input
                            v-model.trim="form.scheduleVehicleTime"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="addTime"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班次排车完成时间">
                        <el-input
                            v-model.trim="form.rowCarEndTime"
                            placeholder="请输入"
                            maxlength="20"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="到车登记时长(min)"
                        prop="arriveVehicleTime"
                    >
                        <el-input
                            v-model.trim="form.arriveVehicleTime"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="addTime"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班次到车登记完成时间">
                        <el-input
                            v-model.trim="form.arrivalEndTime"
                            placeholder="请输入"
                            maxlength="20"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="出库时长(min)" prop="outWarehouseTime">
                        <el-input
                            v-model.trim="form.outWarehouseTime"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="addTime"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班次出库完成时间">
                        <el-input
                            v-model.trim="form.outEndTime"
                            placeholder="请输入"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="装车时长(min)" prop="loadVehicleTime">
                        <el-input
                            v-model.trim="form.loadVehicleTime"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="addTime"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班次装车完成时间">
                        <el-input
                            v-model.trim="form.loadEndTime"
                            placeholder="请输入"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="发车时长(min)" prop="startVehicleTime">
                        <el-input
                            v-model.trim="form.startVehicleTime"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="addTime"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                 <el-col :span="12">
                    <el-form-item label="班次发车完成时间">
                        <el-input
                            v-model.trim="form.departEndTime"
                            placeholder="请输入"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item
                        label="班次签收/抵达时长(h)"
                        prop="arrivalToReceipt"
                    >
                        <el-input
                            v-model.trim="form.arrivalToReceipt"
                            oninput="if(isNaN(value)){value = null} if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+0)}"
                            placeholder="请输入"
                            maxlength="10"
                            clearable
                            @change="arrivalToReceiptChange"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班次签收/抵达完成时间">
                        <el-input
                            v-model.trim="form.receiptEndTime"
                            placeholder="请输入"
                            disabled
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生效时间" prop="activeTime">
                        <el-date-picker
                            v-model="form.activeTime"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择生效时间"
                            :disabled="
                                title === '编辑' && +rowData.status === 2
                            "
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="失效时间" prop="invalidTime">
                        <el-date-picker
                            v-model="form.invalidTime"
                            :picker-options="{
                                disabledDate: (time) => {
                                    return time.getTime() < new Date()
                                },
                            }"
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            placeholder="选择失效时间"
                            :disabled="
                                title === '编辑' && +rowData.status === 2
                            "
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSure" :loading="loading"
                >保 存</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import advanceDialog from '@/components/lots/otpAdvance';
import { getStrategyAdd, getStrategyUpdate } from '@otp/api/classesStrategy.js';
import otpSelect from '@/components/lots/otpSelect';
import dayjs from 'dayjs';

export default {
    components: { advanceDialog, otpSelect },
    data () {
        return {
            form: {
                siteCode: '',
                siteName: '',
                companyName: '',
                companyCode: '',
                lineLevel: '',
                lineName: '',
                lineCode: '',
                shiftOrderEndTime: '',
                shiftName: '',
                scheduleVehicleTime: '30', // 班次排车时长
                arriveVehicleTime: '60', // 班次到车登记时长
                outWarehouseTime: '60', // 班次出库时长
                loadVehicleTime: '60', // 班次装车时长
                startVehicleTime: '30', // 班次发车时长
                arrivalToReceipt: '24', // 班次签收/抵达时长
                activeTime: '',
                rowCarEndTime: '',
                arrivalEndTime: '',
                outEndTime: '',
                loadEndTime: '',
                departEndTime: '',
                receiptEndTime: '',
                invalidTime: ''
            },
            loading: false,
            companyParams: {
                name: '分公司',
                value: 'companyName',
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', value: '分公司名称' },
                    { prop: 'escoCompanyNo', value: '分公司编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNo', value: '分公司编码' },
                    { prop: 'escoCompanyNameCn', value: '分公司名称' }
                ],
                advanceUrl: '/searchBrand',
                cbParams: ['escoCompanyNameCn#companyName', 'escoCompanyNo#companyCode']
            },
            siteParams: {
                name: '服务平台',
                value: 'siteName',
                type: 'advance',
                advanceConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                tableConfig: [
                    { prop: 'escoCompanyNameCn', 'value': '平台名称' },
                    { prop: 'escoCompanyNo', 'value': '平台编码' }
                ],
                advanceUrl: '/searchPlatform',
                cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
                advanceCascade: 'companyCode'
            },
            lineParams: {
                name: '线路名称',
                value: 'lineName',
                type: 'advance',
                multiple: true,
                border: true,
                dialogWidth: '800px',
                multipleTableColumn: {
                    prop: 'lineName', value: '线路名称'
                },
                advanceConfig: [
                    { prop: 'lineCode', value: '线路编号' },
                    { prop: 'lineName', value: '线路名称' },
                    { prop: 'startWhName', value: '始发仓名称' },
                    { prop: 'destProvinceName', value: '目地省' },
                    { prop: 'destCityName', value: '目地市' },
                    { prop: 'destDistrictName', value: '目地区' }
                ],
                tableConfig: [
                    { prop: 'lineCode', value: '线路编号' },
                    { prop: 'lineName', value: '线路名称' }
                ],
                prefix: '/api-opms/',
                advanceUrl: 'opms/line/queryPage',
                method: 'post',
                paramType: true,
                cbParams: ['lineCode', 'lineName'],
                advanceCascade: 'lineLevel'
            },
            rules: {
                arrivalToReceipt: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                scheduleVehicleTime: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                arriveVehicleTime: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                outWarehouseTime: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                loadVehicleTime: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                startVehicleTime: [
                    { required: true, message: '请输入', trigger: 'blur' }
                ],
                companyName: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                lineLevel: [
                    { required: true, message: '请选择线路模式', trigger: 'change' }
                ],
                lineName: [
                    { required: true, message: '请选择线路', trigger: 'change' }
                ],
                shiftOrderEndTime: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                activeTime: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                invalidTime: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                siteName: [
                    { required: true, message: '请选择服务平台', trigger: 'change' }
                ]
            }
        };
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '新增'
        },
        rowData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    mounted () {
        if (this.title === '编辑') {
            this.form = JSON.parse(JSON.stringify(this.rowData));
            this.$set(this.form, 'activeTime', dayjs(this.form.activeTime).format('YYYY-MM-DD'));
            this.$set(this.form, 'invalidTime', dayjs(this.form.invalidTime).format('YYYY-MM-DD'));
        } else if (this.title === '复制') {
            const rowData = JSON.parse(JSON.stringify(this.rowData));
            Object.keys(this.form).forEach(key => {
                this.form[key] = rowData[key];
            });
            ['shiftName', 'activeTime', 'invalidTime'].forEach(key => {
                this.$set(this.form, key, '');
            });
        }
        this.arrivalToReceiptChange();
    },
    methods: {
        getSelectValue (data, type) {
            this.form = {
                ...this.form,
                ...data
            };
            if (type === 'lineLevel') {
                this.$set(this.form, 'lineName', '');
                this.$set(this.form, 'lineCode', '');
            }
            if (type === 'companyName') {
                this.$set(this.form, 'siteName', '');
                this.$set(this.form, 'siteCode', '');
            }
        },
        shiftOrderEndTimeChange () {
            this.addTime();
        },
        arrivalToReceiptChange () {
            // 班次签收/抵达完成时间
            const receiptEndTime = this.receiptEndTimeFormat(this.form.arrivalToReceipt);
            this.$set(this.form, 'receiptEndTime', receiptEndTime);
        },
        // 根据时长自动计算对应时间
        addTime () {
            // 班次排车完成时间
            const rowCarEndTime = this.time(this.form.shiftOrderEndTime, this.form.scheduleVehicleTime);
            this.$set(this.form, 'rowCarEndTime', rowCarEndTime);
            // 班次到车登记完成时间
            const arriveVehicleTime = +this.form.scheduleVehicleTime + +this.form.arriveVehicleTime;
            const arrivalEndTime = this.time(this.form.shiftOrderEndTime, arriveVehicleTime);
            this.$set(this.form, 'arrivalEndTime', arrivalEndTime);
            // 班次出库完成时间
            const outWarehouseTime = +this.form.scheduleVehicleTime + +this.form.arriveVehicleTime + +this.form.outWarehouseTime;
            const outEndTime = this.time(this.form.shiftOrderEndTime, outWarehouseTime);
            this.$set(this.form, 'outEndTime', outEndTime);
            // 班次装车完成时间
            const loadVehicleTime = +this.form.scheduleVehicleTime + +this.form.arriveVehicleTime + +this.form.outWarehouseTime + +this.form.loadVehicleTime;
            const loadEndTime = this.time(this.form.shiftOrderEndTime, loadVehicleTime);
            this.$set(this.form, 'loadEndTime', loadEndTime);
            // 班次发车完成时间
            const startVehicleTime = +this.form.scheduleVehicleTime + +this.form.arriveVehicleTime +
                +this.form.outWarehouseTime + +this.form.loadVehicleTime + +this.form.startVehicleTime;
            const departEndTime = this.time(this.form.shiftOrderEndTime, startVehicleTime);
            this.$set(this.form, 'departEndTime', departEndTime);
            const c = this.form.shiftOrderEndTime.split(':');
            const d = c[0] * 60 + c[1] * 1 + outWarehouseTime * 1;
            if (this.form.siteName.includes('配送中心')) {
                if (Math.floor((d / 60) / 24) > 1 || (Math.floor((d / 60) / 24) === 1 && Math.floor(d / 60) % 24 > 16) ||
                    (Math.floor((d / 60) / 24) === 1 && Math.floor(d / 60) % 24 === 16 && d % 60 > 0)) {
                    this.$message.warning('班次出库完成时间超次日16时，是否保存?');
                }
            }
            if (this.form.siteName.includes('电商中心')) {
                if (Math.floor((d / 60) / 24) > 0) {
                    this.$message.warning('班次出库完成时间超次日0时，是否保存?');
                }
            }
        },
        time (a, b) {
            const c = a.split(':');
            const d = c[0] * 60 + c[1] * 1 + b * 1;
            if ((d / 60) / 24 >= 1) { // 判断是否为第二天
                return `N+${Math.floor((d / 60) / 24)}  ${this.buling((Math.floor(d / 60) % 24))} : ${this.buling(d % 60)}`;
            } else {
                return `N ${this.buling((Math.floor(d / 60) % 24))} : ${this.buling(d % 60)}`;
            }
        },
        receiptEndTimeFormat (time) {
            const d = time - 1;
            if (d / 24 >= 1) { // 判断是否为第二天
                return `N+${Math.floor((d / 24)) + 1} ${this.buling((d % 24))}:59:59`;
            } else {
                return `N+1 ${this.buling((d % 24))}:59:59`;
            }
        },
        // 补零
        buling (num) {
            if (num < 10) {
                return '0' + num;
            }
            return num;
        },
        handleClose () {
            this.form = {};
            this.$emit('handleClose');
        },
        isValidDate (startDate, endDate) {
            return (endDate.getTime() > startDate.getTime() || endDate.getTime() === startDate.getTime());
        },
        handleSure () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    if (!this.isValidDate(new Date(this.form.activeTime), new Date(this.form.invalidTime))) {
                        return this.$message.warning('失效时间必须大于生效时间！');
                    }
                    this.loading = true;
                    if (this.title === '编辑') {
                        getStrategyUpdate(this.form)
                            .then((res) => {
                                if (res && +res.code === 0) {
                                    this.$message.success('编辑成功');
                                    this.$emit('handleClose', true);
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    } else {
                        getStrategyAdd(this.form)
                            .then((res) => {
                                if (res && +res.code === 0) {
                                    this.$message.success('新增成功');
                                    this.$emit('handleClose', true);
                                }
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                } else {
                    return false;
                }
            });
        }
    }
};
</script>
<style lang='less'>
.classes-strategy-dialog {
    .el-date-editor--datetimerange.el-input__inner,
    .el-select {
        width: 100%;
    }
    .from {
        .el-form-item__content .el-input-group {
            vertical-align: middle;
        }
        .el-form-item__label,
        .el-form-item__content {
            line-height: 40px;
        }
        .el-form-item {
            margin-bottom: 14px;
        }
        .el-date-editor.el-input,
        .el-date-editor.el-input__inner {
            width: 100%;
        }
    }
    .row-item{
        width: 80%;
        padding-left: 10%;
    }
}
</style>
